// v77 · OVERALL RANK — JEDAN IZVOR ISTINE
//
// Bag koji je Filip prijavio 07.09.2026: hero kartica na dashboardu pokazuje
// 74K, a manager modal 42.943 — za isti tim, na istom ekranu, u istoj sekundi.
//
// Uzrok NIJE bio nas racun nego dva razlicita FPL endpointa:
//   /entry/{id}/                        summary_overall_rank        73.803  <- svez
//   /entry/{id}/history/                current[GW3].overall_rank   42.943  <- snimak
//   /entry/{id}/event/3/picks/          entry_history.overall_rank  42.943  <- isti snimak
// Zvanicna FPL stranica entry/3079777/event/3 u istom trenutku: 241 poena,
// overall rank 73.803, GW poeni 54. Snimak je govorio 237 / 42.943 / 50.
// event-status za GW3: bonus_added:false, points:"p" — svih 10 meceva FT, ali
// kolo NIJE obradjeno. U tom prozoru snimak zaostaje, /entry/ ide uzivo.
//
// PRAVILA KOJA OVAJ SLOJ SPROVODI:
//  1. Tekuci rank UVEK dolazi iz /entry/ (liveRank). History je samo fallback.
//  2. Najbolji/najgori se racunaju SAMO iz zavrsenih kola (event < currentGwId).
//     Red tekuceg kola nosi provizornu vrednost: 42.943 je rang koji Filip nikad
//     nije imao, a curio je u Math.min kao "najbolji overall rank".
//  3. liveRank ULAZI u skup za min/max. Bez toga bi "najbolji" bio 75.693 (GW2),
//     a "trenutni" 73.803 — kartica bi i dalje protivrecila sama sebi.
//  4. Kad se kolo obradi, history se sam poravna sa /entry/. Skup tada sadrzi
//     isti broj dvaput, rezultat je identican. Nema zaostalog stanja i nema
//     nicega sto treba rucno ocistiti.

// Rangovi iz ZAVRSENIH kola. Red tekuceg kola se namerno izostavlja jer je
// provizoran dok FPL ne obradi kolo.
export function zavrsenaKola(history, currentGwId) {
  const redovi = Array.isArray(history && history.current) ? history.current : [];
  return redovi
    .filter((gw) => (currentGwId ? gw.event < currentGwId : true))
    .filter((gw) => typeof gw.overall_rank === "number" && gw.overall_rank > 0)
    .map((gw) => gw.overall_rank);
}

// Vraca null kad nema nijednog upotrebljivog broja — pozivalac tada ne crta karticu.
// highest/lowest su null kad nema nijednog zavrsenog kola (npr. tokom GW1):
// tada postoji samo tekuci rank i nema sta da se poredi.
export function overallRankStats(history, liveRank, currentGwId) {
  const zavrseni = zavrsenaKola(history, currentGwId);
  const live = typeof liveRank === "number" && liveRank > 0 ? liveRank : null;

  if (live === null && zavrseni.length === 0) return null;

  const current = live !== null ? live : zavrseni[zavrseni.length - 1];
  const skup = live !== null ? zavrseni.concat(live) : zavrseni;

  // "prethodni" sluzi ISKLJUCIVO strelici gore/dole i mora biti poslednje
  // ZAVRSENO kolo. Kad nema liveRank-a, current vec JESTE poslednje zavrseno
  // kolo, pa se poredi sa pretposlednjim — inace bi se poredio sam sa sobom.
  const previous =
    live !== null
      ? (zavrseni.length ? zavrseni[zavrseni.length - 1] : null)
      : (zavrseni.length >= 2 ? zavrseni[zavrseni.length - 2] : null);

  // manji rank = bolje
  let direction = null;
  if (previous !== null && previous !== current) {
    direction = current < previous ? "up" : "down";
  }

  return {
    current,
    highest: zavrseni.length ? Math.min.apply(null, skup) : null,
    lowest: zavrseni.length ? Math.max.apply(null, skup) : null,
    previous,
    direction,
  };
}
